import state from '../store';
import * as api from '../api';
export var orgDomain = function orgDomain() {
  if (!state.isBrowser) {
    return state.localStorage.getItem('domain') || '';
  }
  // 本地host环境使用调试域名
  if (window.location.host.indexOf('localhost') > -1) {
    return window.localStorage.getItem('testDomain');
  }
  // 存在配置中心配置时，如果当前域名为非机构域名则跳过
  if (window.feConfig && window.feConfig.common && [window.feConfig.common.commonDomainH5,
  // 移动端通用域名
  window.feConfig.common.dingDomainPc,
  // 钉钉ISV域名
  window.feConfig.common.qw // 企业微信ISV域名
  ].filter(function (url) {
    return url.indexOf('//' + window.location.host) > -1;
  }).length) {
    return '';
  }
  return window.location.host;
};
function getQuery(search, target) {
  var res = [];
  if (!search) return res;
  try {
    var str = search.split('?')[1];
    if (!str) return res;
    var querys = str.split('&');
    var lowwerTarget = target.toLowerCase();
    for (var i = 0; i < querys.length; i++) {
      if (!querys[i]) continue;
      var tmp = querys[i].split('=');
      if (tmp[0].toLowerCase() === lowwerTarget) {
        res.push(tmp[1]);
      }
    }
  } catch (e) {}
  return res;
}
export var orgId = function orgId() {
  var _location = window.location || {};
  return state.localStorage.getItem('orgId') || getQuery(_location.search || _location.hash, 'orgId')[0] || getQuery(_location.search || _location.hash, 'og')[0];
};
export var staticBaseUrl = (state.isBrowser ? state.staticBaseUrl : api.domains.staticBaseUrl) || 'https://stc.yxt.com/';